import { Card, Divider, Modal, Typography } from "antd";
import React, { useState } from "react";
import ClientAddressList from "./ClientAddressList";
import ClientForm from "./ClientForm";
import ClientList from "./ClientList";
import { addClient, updateClient } from "../../services/clientService";
import "./ClientStyles.css";

const { Title } = Typography;

const ClientManagement = () => {
	const [refreshKey, setRefreshKey] = useState(0);
	const [selectedClient, setSelectedClient] = useState(null);
	const [selectedClientForAddresses, setSelectedClientForAddresses] = useState(null);
	const [openClientFormModal, setOpenClientFormModal] = useState(false);
	const [openAdressFormModal, setOpenAdressFormModal] = useState(false);
	const isMobile = window.innerWidth < 768;
	const [loadingClientForm, setLoadingClientForm] = useState(false);
	const [error, setError] = useState("");
	const [isCreate, setIsCreate] = useState(false);

	// Esta función se ejecutará cuando se agregue un nuevo cliente
	const handleClientAdded = () => {
		// Incrementar el key para forzar la actualización de la lista de clientes
		setRefreshKey((prevKey) => prevKey + 1);
	};

	const handleOpenForm = (client) => {
		setSelectedClient(client);
		setOpenClientFormModal(true);
		setIsCreate(false);
	};

	// Esta función se ejecutará cuando se actualice un cliente
	const handleClientUpdated = () => {
		// Limpiar el cliente seleccionado e incrementar el key para actualizar la lista
		setSelectedClient(null);
		setRefreshKey((prevKey) => prevKey + 1);
	};

	// Esta función se ejecutará cuando se quiera ver las direcciones de un cliente
	const handleViewAddresses = (client) => {
		setSelectedClientForAddresses(client);
		setOpenAdressFormModal(true);
	};

	const handleSubmitClientForm = async (clientData) => {
		try {
			setError("");
			setLoadingClientForm(true);

			if (selectedClient != null) {
				await updateClient(selectedClient.id, { ...clientData, pendingSync: 1 });
				window.messageApi.success("Cliente actualizado correctamente");
				handleClientUpdated();
			} else {
				await addClient({ ...clientData, pendingSync: 1 });
				window.messageApi.success("Cliente registrado correctamente");
				handleClientAdded();
			}
		} catch (error) {
			setError(error.message || "Error al procesar el cliente");
			console.error("Error al procesar cliente:", error);
		} finally {
			setLoadingClientForm(false);
			setOpenClientFormModal(false);
		}
	};

	const handleCancelClientForm = (form) => {
		form.resetFields();
		setSelectedClient(null);
		setOpenClientFormModal(false);
	};

	const handleOpenClientFormModal = () => {
		setSelectedClient(null);
		setOpenClientFormModal(true);
		setIsCreate(true);
	};

	return (
		<div className="client-management-container">
			<Title level={2}>{isMobile ? "Clientes" : "Gestión de clientes"}</Title>
			<Divider />

			<ClientList
				refreshTrigger={refreshKey}
				onOpenForm={handleOpenForm}
				onViewAddresses={handleViewAddresses}
				onAddClient={handleOpenClientFormModal}
			/>

			{/* Modal crear/editar clientes*/}
			<Modal
				title="Formulario de Cliente"
				open={openClientFormModal}
				onCancel={() => { setOpenClientFormModal(false) }}
				footer={null}
				width={isMobile ? "95%" : 700}
				destroyOnHidden
			>
				<Card>
					<ClientForm
						initialData={selectedClient}
						loadingForm={loadingClientForm}
						error={error}
						handleSubmit={handleSubmitClientForm}
						handleCancel={handleCancelClientForm}
						handleError={setError}
						isCreate={isCreate}

					/>
				</Card>
			</Modal>

			{/* Modal para editar direcciones de cliente*/}
			<Modal
				title="Direcciones del Cliente"
				open={openAdressFormModal}
				onCancel={() => { setOpenAdressFormModal(false) }}
				footer={null}
				width={isMobile ? "95%" : 700}
				destroyOnHidden
			>
				<ClientAddressList
					clientNo={selectedClientForAddresses?.No}
					clientName={selectedClientForAddresses?.name}
				/>
			</Modal>

		</div>
	);
};

export default ClientManagement;
